import React from 'react'
import { observer } from 'mobx-react'

import {
  Section,
  SectionContent,
  SectionHeader,
  useSection,
} from 'components/Section'

import styles from './AssessmentSection.sass'
import {
  Dropdown,
  DropdownItem,
  DropdownItemTitle,
  DropdownTitle,
} from 'components/Dropdown'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import BookkeepingManagerDetailsViewModel from '../BookkeepingManagerDetailsViewModel'

interface AssessmentSectionProp {
  vm: BookkeepingManagerDetailsViewModel
}

export default observer(function AssessmentSection({
  vm,
}: AssessmentSectionProp) {
  const sectionProps = useSection(false)

  return (
    <Section {...sectionProps}>
      <SectionHeader
        actions={
          <>
            {(vm.job?.canUpdateJobScope || vm.job?.canRequestScopeChanges) && (
              <Dropdown
                autoDismiss
                button={
                  <IconButton>
                    <Icon name="more" rotate={90} />
                  </IconButton>
                }
              >
                <DropdownTitle>Actions</DropdownTitle>

                {vm.job?.canRequestScopeChanges &&
                  !vm.canRequestScopeChanges && (
                    <DropdownItem onClick={() => vm.viewChangeRequests()}>
                      <DropdownItemTitle>
                        View change requests
                      </DropdownItemTitle>
                    </DropdownItem>
                  )}

                {vm.canRequestScopeChanges && (
                  <DropdownItem onClick={vm.requestScopeChangesVM?.show}>
                    <DropdownItemTitle>Request scope changes</DropdownItemTitle>
                  </DropdownItem>
                )}
                {vm.canUpdateJobScope && (
                  <DropdownItem onClick={vm.updateJobScopeVM?.show}>
                    <DropdownItemTitle>Update job scope</DropdownItemTitle>
                  </DropdownItem>
                )}
              </Dropdown>
            )}
          </>
        }
      >
        Pro assessment
      </SectionHeader>
      <SectionContent>
        <SectionItem
          label="Number of bank accounts"
          value={vm.bookkeepingAssessment.numberOfBankAccounts}
        />
        <SectionItem
          label="Last 3 month average monthly expenses"
          value={vm.bookkeepingAssessment.avgMonthlyExpensesDisplay}
        />

        {vm.bookkeepingAssessment.cleanup?.reason && (
          <SectionItem
            label="Customer requires a cleanup"
            value={vm.bookkeepingAssessment.cleanup.reason}
          />
        )}

        {vm.bookkeepingAssessment.comment && (
          <SectionItem
            label="Comments"
            value={vm.bookkeepingAssessment.comment}
          />
        )}
      </SectionContent>
    </Section>
  )
})

interface SectionItemProps {
  label: string
  value: string | number
}

function SectionItem({ label, value }: SectionItemProps) {
  return (
    <div className={styles.item}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  )
}
